import { scrollTo } from "../scrollTo/index.js";

document.addEventListener(
  "click",
  (e) => {
    const ref = e.target.closest("[data-footnote]");
    if (!ref) return;

    e.preventDefault();
    e.stopPropagation();

    const hash = ref.dataset.footnote;
    const targetEl = document.getElementById(hash.replace("#", ""));
    if (!targetEl) return;

    const wrapper = targetEl.closest(".accordion__wrapper");
    const triggerId = wrapper
      ? wrapper.querySelector(".accordion__trigger[data-id]")?.dataset?.id
      : targetEl.nextElementSibling?.querySelector(".accordion__trigger")?.dataset?.id;
    if (triggerId) {
      window.dispatchEvent(new CustomEvent("open-accordion", { detail: { id: triggerId } }));
    }

    scrollTo(targetEl);
  },
  true
);
